import config from './config.json'
import http from './httpService'

export const sendCodeGoogle = obj => {
    return http.post(`${config.coinbaseapi}/auth/google`, obj)
}